<mat-toolbar>
  <h4 mat-dialog-title style="width: 100%"></h4>
  <span class="fill-remaining-space"></span>
  <button class="btn-dialog-close" mat-raised-button (click)="onClose()" tabindex="-1">
    <mat-icon>clear</mat-icon>
  </button>
</mat-toolbar>

<mat-dialog-content>
  <form [formGroup]="groupForm">
    <fieldset>
      <legend>Datos del Grupo</legend>

      <div class="row">
        <div class="col-12 col-md">
          <mat-form-field>
            <mat-label>Nombre del Grupo</mat-label>
            <input type="text" matInput formControlName="name">
          </mat-form-field>
        </div>

        <ng-container *ngIf="group && group.id > 0">
          <div class="col-12 col-md">
            <mat-form-field>
              <mat-label>Fecha de inicio</mat-label>
              <input type="text" matInput formControlName="initial_date">
            </mat-form-field>
          </div>
        </ng-container>

      </div>

    </fieldset>
    <br>
    <button class="float-right" mat-raised-button color="primary" (click)="save()" [disabled]="groupForm.invalid">{{groupForm.controls.id.value > 0 ? 'Actualizar' : 'Guardar' }}</button>
  </form>
</mat-dialog-content>
<hr>
<mat-dialog-actions align="end">
  <button class="btn" mat-stroked-button (click)="onClose()">Cerrar Ventana</button>
</mat-dialog-actions>


